export const showPasswordIcon = () => {
    return (
        <svg
        xmlns="http://www.w3.org/2000/svg"
        width={32}
        height={32}
        viewBox="0 0 36 36"
        fill="rgba(0, 0, 0, 0.5)"
      >
        <title>{"eye-show-line"}</title>
        <path
          d="M33.62 17.53c-3.37-6.23-9.28-10-15.82-10S5.34 11.3 2 17.53l-.28.47.26.48c3.37 6.23 9.28 10 15.82 10s12.46-3.72 15.82-10l.26-.48Zm-15.82 8.9C12.17 26.43 7 23.29 4 18c3-5.29 8.17-8.43 13.8-8.43S28.54 12.72 31.59 18c-3.05 5.29-8.17 8.43-13.79 8.43Z"
          className="clr-i-outline clr-i-outline-path-1"
        />
        <path
          d="M18.09 11.17A6.86 6.86 0 1 0 25 18a6.86 6.86 0 0 0-6.91-6.83Zm0 11.72A4.86 4.86 0 1 1 23 18a4.87 4.87 0 0 1-4.91 4.89Z"
          className="clr-i-outline clr-i-outline-path-2"
        />
        <path fill="none" d="M0 0h36v36H0z" />
      </svg>
    );
};

export const hidePasswordIcon = () => {
    return (
        <svg
        xmlns="http://www.w3.org/2000/svg"
        width={32}
        height={32}
        viewBox="0 0 36 36"
        fill="rgba(0, 0, 0, 0.5)"
      >
        <title>{"eye-hide-solid"}</title>
        <path
          d="M18.37 11.17a6.79 6.79 0 0 0-2.37.43l8.8 8.8a6.78 6.78 0 0 0 .43-2.4 6.86 6.86 0 0 0-6.86-6.83Z"
          className="clr-i-solid clr-i-solid-path-1"
        />
        <path
          d="M34.29 17.53c-3.37-6.23-9.28-10-15.82-10a16.82 16.82 0 0 0-5.24.85L14.84 10a14.78 14.78 0 0 1 3.63-.47c5.63 0 10.75 3.14 13.8 8.43a17.75 17.75 0 0 1-4.37 5.1l1.42 1.42a19.93 19.93 0 0 0 5-6l.26-.48Z"
          className="clr-i-solid clr-i-solid-path-2"
        />
        <path
          d="m4.87 5.78 4.46 4.46a19.52 19.52 0 0 0-6.69 7.29l-.26.47.26.48c3.37 6.23 9.28 10 15.82 10a16.93 16.93 0 0 0 7.37-1.69l5 5 1.75-1.5-26-26Zm8.3 8.3a6.85 6.85 0 0 0 9.55 9.55l1.6 1.6a14.91 14.91 0 0 1-5.86 1.2c-5.63 0-10.75-3.14-13.8-8.43a17.29 17.29 0 0 1 6.12-6.3Z"
          className="clr-i-solid clr-i-solid-path-3"
        />
        <path fill="none" d="M0 0h36v36H0z" />
      </svg>
    );
};
